import { render, staticRenderFns } from "./googlePhoneBind.vue?vue&type=template&id=5275f40a&scoped=true"
import script from "./googlePhoneBind.vue?vue&type=script&lang=js"
export * from "./googlePhoneBind.vue?vue&type=script&lang=js"
import style0 from "./googlePhoneBind.vue?vue&type=style&index=0&id=5275f40a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275f40a",
  null
  
)

export default component.exports